"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CreditTerms = void 0;
var React = _interopRequireWildcard(require("react"));
var style = _interopRequireWildcard(require("./CreditTerms.css"));
var _uiKit = require("@cian/ui-kit");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const CreditTerms = props => {
  const {
    terms
  } = props;
  if (!terms || terms.length === 0) {
    return null;
  }
  return /*#__PURE__*/React.createElement("div", {
    className: style['credit-terms']
  }, /*#__PURE__*/React.createElement(_uiKit.UIHeading4, {
    fontWeight: "bold"
  }, "\u0412\u0441\u0435\xA0\u0443\u0441\u043B\u043E\u0432\u0438\u044F \u043A\u0440\u0435\u0434\u0438\u0442\u0430"), /*#__PURE__*/React.createElement("div", {
    className: style['terms']
  }, terms.map((_ref, idx) => {
    let {
      title,
      value
    } = _ref;
    return /*#__PURE__*/React.createElement(React.Fragment, {
      key: idx
    }, /*#__PURE__*/React.createElement(_uiKit.UIText1, {
      color: "text-secondary-default"
    }, title), /*#__PURE__*/React.createElement(_uiKit.UIText1, {
      color: "text-primary-default"
    }, value));
  })));
};
exports.CreditTerms = CreditTerms;